import React from 'react';
import { DomHelpers } from '@salesperformanceint/e4shared';
import Toggle from 'components/prism/toggle';

export const ButtonGroup = ({ text, section, setSection, loading }) => {
    const loaded = React.useRef(null);

    const resizeHandler = () => {
        const containers = document.getElementsByClassName('prism-metric-score-value');
        [...containers].map(x => DomHelpers.shrinkFont('label-text-fit', 32, x));
    };

    React.useEffect(() => {
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    React.useEffect(() => {
        if (loaded?.current) {
            resizeHandler();
        }
    }, [loaded?.current, loading]);

    React.useEffect(() => {
        switch (section) {
            case 'AllBehaviours':
                setSection('AllBehaviours');
                break;
            case 'InProgress':
                setSection('InProgress');
                break;
            case 'Completed':
                setSection('Completed');
                break;
        }
    }, [section]);

    return (
        <div ref={loaded}>
            <div className="two-col flex flex-center mb10">
                <div className="text-left">
                    <Toggle value={section} onChange={setSection}>
                        <button value="AllBehaviours">{text.allBehaviours}</button>
                        <button value="InProgress">{text.inProgress}</button>
                        <button value="Completed">{text.completed}</button>
                    </Toggle>
                </div>
            </div>
        </div>
    );
};

export default ButtonGroup;
